module.exports = __webpack_public_path__ + "img/ear_32x32_white.34085c9f.svg";